export const useBiddingUserSubmitted = ({ status, cost, user }) => {
  const empty = '-';

  switch (status) {
    case 'UnConfirmed':
      return empty;
    case 'Award':
    case 'No award':
      return cost && cost > 0 ? user : empty;
    default:
      return user;
  }
};
